import { Component, OnInit } from '@angular/core';
import { TipoTalonarioLabels } from '@tivic-team/manager-ts/dist/mob/enums/talonario/tipo-talonario.enum';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'dropdown-talonario-tipo',
  templateUrl: './dropdown-talonario-tipo.component.html',
  styleUrls: ['./dropdown-talonario-tipo.component.scss'],
  viewProviders: [ ParentFormGroup ]
})
export class DropdownTalonarioTipoComponent implements OnInit {

  tipoTalao = TipoTalonarioLabels;

  constructor() { }

  ngOnInit() {
  }

}
